import React from 'react';
import { Placeholder, Spinner } from '@vkontakte/vkui';

export function LoadingRing() {
  return <Spinner size="regular" />;
}

export function EmptyState({ text = 'Список пуст ¯\\_(ツ)_/¯' }) {
  return <Placeholder>{text}</Placeholder>;
}

export function LoadingBlock() {
  return (
    <div className="py-4">
      <Spinner size="regular" />
    </div>
  );
}
